export default {
  methods: {
    uriToFilters(query, params) {
      const filters = {
        districts: [],
      };

      if (params.p1) {
        const found = this.paramOptions.find(po => po.option === params.p1);
        if (found) {
          filters[found.key] = found.value;
        }
      }
      if (params.p2) {
        const found = this.paramOptions.find(po => po.option === params.p2);
        if (found) {
          filters[found.key] = found.value;
        }
      }

      Object.keys(query).forEach((queryKey) => {
        const filterAttr = queryKey.replace(
          /_([a-z])/g,
          (m, p1) => p1.toUpperCase(),
        );
        if (Array.isArray(filters[filterAttr])) {
          if (filterAttr === 'districts') {
            if (Array.isArray(query[queryKey])) {
              filters[filterAttr] = query[queryKey];
            } else {
              filters[filterAttr] = query[queryKey].split(',');
            }
          } else if (Array.isArray(query[queryKey])) {
            Array.prototype.push.apply(filters[filterAttr], query[queryKey]);
          } else {
            filters[filterAttr].push((query[queryKey]));
          }
        } else {
          filters[filterAttr] = query[queryKey];
        }
      });

      return filters;
    },
    filtersToUri(rawFilters, noParams = false) {
      let { icsType, buildingType, txType, ...filters } = rawFilters;

      if (noParams) {
        icsType = null;
        txType = null;
        buildingType = null;
        filters = rawFilters;
      }

      let foundIcsType;
      let foundTxType;

      if (icsType) {
        foundIcsType = this.paramOptions.find(po => po.value === icsType);
      }

      if (buildingType) {
        foundIcsType = this.paramOptions.find(po => po.value === buildingType);
      }
      if (Array.isArray(txType)) {
        foundTxType = this.paramOptions.find((po) => {
          if (!Array.isArray(po.value)) {
            return false;
          }
          if (txType.length !== po.value.length) {
            return false;
          }
          return txType.every(tt => po.value.includes(tt));
        });
      }

      const params = {};
      if (foundIcsType && !foundTxType) {
        params.p1 = foundIcsType.option;
      } else if (!foundIcsType && foundTxType) {
        params.p1 = foundTxType.option;
      } else if (foundIcsType && foundTxType) {
        params.p1 = foundIcsType.option;
        params.p2 = foundTxType.option;
      }

      const query = {};
      Object.keys(filters).forEach((filterAttr) => {
        const queryKey = filterAttr.replace(
          /([A-Z])/g,
          m1 => `_${m1.toLowerCase()}`,
        );
        if (queryKey === 'districts') {
          if (filters[filterAttr].length > 0) {
            query[queryKey] = filters[filterAttr].join(',');
          }
        } else if (filters[filterAttr]) {
          query[queryKey] = filters[filterAttr];
        }
      });

      return {
        params,
        query,
      };
    },

    absoluteUrl(path, filters = {}) {
      const base = `${window.location.origin}${window.SITE_URL}`;
      let url = `${path}`;

      if (filters.params) {
        if (filters.params.p1) {
          url = `${url}/${filters.params.p1}`;
        }
        if (filters.params.p2) {
          url = `${url}/${filters.params.p2}`;
        }
      }

      if (filters.query) {
        const q = new URLSearchParams(filters.query).toString();
        url = `${url}?${q}`;
      }

      url = `${base}${url}`;

      return url;
    },

  },
};
